var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _vm.records.length
            ? [
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c("LoadingButton", {
                      attrs: {
                        title: "Сохранить",
                        type: "button",
                        className: "btn btn-success btn-sm",
                        onClick: () => _vm.saveSelected(),
                        loading: _vm.loadingBtn,
                        color: "white",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-1" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (d, i) {
                        return _c("tr", { key: i }, [
                          _c("td", [_vm._v(_vm._s(i + 1))]),
                          _vm._v(" "),
                          _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selected[d.id],
                                  expression: "selected[d.id]",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.selected[d.id])
                                  ? _vm._i(_vm.selected[d.id], null) > -1
                                  : _vm.selected[d.id],
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.selected[d.id],
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.selected,
                                          d.id,
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.selected,
                                          d.id,
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.selected, d.id, $$c)
                                  }
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(d.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(d.title))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(d.price))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(d.in_store))]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Цена")]),
        _vm._v(" "),
        _c("th", [_vm._v("Остаток")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }